import { create } from "zustand";

/**
 * 「這一頁的頁首現在是一張滿版地圖」。
 *
 * 只有配送追蹤元件知道地圖在不在（要等後端回座標才知道），但要讓地圖鋪到畫面最上緣，
 * 得由 PageWrapper 收掉標題列的讓位內距、並讓標題列在捲到頂時不畫底色——那是它的元素。
 * 兩邊隔著 router 的 Outlet，沒有 props 可傳，所以用一個只有布林值的 store 接。
 *
 * 為什麼不是用負 margin 把地圖拉上去：內容區是捲動容器，往上超出內容原點的部分
 * 會被直接裁掉（block-start 方向的溢出不可捲），怎麼拉都拉不出來。
 */
interface TrackingHeroState {
  active: boolean;
  setActive: (active: boolean) => void;
}

export const useTrackingHero = create<TrackingHeroState>((set) => ({
  active: false,
  setActive: (active) => set((prev) => (prev.active === active ? prev : { active })),
}));
